import HNSColors from "../../../../ui library/HNSColors";

export default function FeeScheduleNetClientCapsule({ value }) {
  const isPositive = value > 0;

  return (
    <div className="mt-2 w-full">
      <div
        className="flex min-h-[40px] items-center justify-between rounded-[8px] px-4 py-2 text-sm font-medium"
        style={{
          backgroundColor: isPositive ? HNSColors.success[700] : HNSColors.failure[700],
          color: isPositive ? HNSColors.success[400] : HNSColors.failure[400],
        }}
      >
        <span className="font-semibold">Net Client</span>
        <span>{value ? `$ ${value}` : "$ 0.00"}</span>
      </div>
    </div>
  );
}
